module.exports = __webpack_public_path__ + "static/media/IMG-1.54e8139c.jpg";